import { Reducer } from 'interfaces'
import { GetCCShipmentAddressAction } from 'components/features/creditCard/creditCardStore/actions'
import { CreditCardDataState } from 'components/features/creditCard/creditCardStore/state'


export const ccShipmentAddressReducer: Reducer<CreditCardDataState['shipmentAddress']> = (prevState = null, action) => {
  switch (action.type) {
    case GetCCShipmentAddressAction.type: {
      if (action.meta !== 'success') {
        return prevState
      }

      return action.payload.response
    }
  }
  return prevState
}
